var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-layout md-gutter md-alignment-top-center" },
    [
      _c(
        "div",
        {
          staticClass:
            "\n      md-layout-item\n      md-size-25\n      md-medium-size-10\n      md-small-size-10\n      md-xsmall-size-0\n    "
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-fab",
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "\n      md-layout-item\n      md-size-50\n      md-medium-size-80\n      md-small-size-80\n      md-xsmall-size-100\n    "
        },
        [
          _c(
            "md-card",
            { staticClass: "md-elevation-2" },
            [
              _c("md-card-header", [
                _c("div", { staticClass: "md-title" }, [
                  _vm._v("Persönliche Einstellungen")
                ])
              ]),
              _vm._v(" "),
              _c(
                "md-card-content",
                [
                  _c(
                    "md-list",
                    [
                      _c("md-list-item", [
                        _c("strong", [_vm._v("Anmeldung zur Mailingliste")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        [
                          _c("md-icon", [_vm._v("email")]),
                          _vm._v(" "),
                          _vm.settings.letter
                            ? _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v("Sie sind in der Mailingliste")
                              ])
                            : _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v("Sie sind nicht in der Mailingliste")
                              ]),
                          _vm._v(" "),
                          _c("md-switch", {
                            model: {
                              value: _vm.settings.letter,
                              callback: function($$v) {
                                _vm.$set(_vm.settings, "letter", $$v)
                              },
                              expression: "settings.letter"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "md-layout md-gutter md-alignment-top-right"
                    },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          on: {
                            click: function($event) {
                              return _vm.saveSettings()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            Einstellungen speichern\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("md-divider", { staticStyle: { "margin-top": "10px" } }),
                  _vm._v(" "),
                  _c(
                    "md-list",
                    [
                      _c("md-list-item", [
                        _c("strong", [_vm._v("Kontoeinstellungen")])
                      ]),
                      _vm._v(" "),
                      !_vm.changepass
                        ? _c(
                            "md-list-item",
                            {
                              on: {
                                click: function($event) {
                                  _vm.changepass = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            Passwort ändern\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.changepass
                        ? _c("div", { staticClass: "md-layout md-gutter" }, [
                            _c(
                              "div",
                              { staticClass: "md-layout-item md-size-100" },
                              [
                                _c(
                                  "form",
                                  {
                                    staticClass: "md-layout",
                                    attrs: { novalidate: "" },
                                    on: {
                                      submit: function($event) {
                                        $event.preventDefault()
                                        return _vm.validatePass.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-field",
                                      {
                                        class: _vm.getValidationClass(
                                          "password"
                                        )
                                      },
                                      [
                                        _c("label", [_vm._v("Neues Passwort")]),
                                        _vm._v(" "),
                                        _c("md-input", {
                                          attrs: {
                                            name: "password",
                                            type: "password",
                                            disabled: _vm.sending
                                          },
                                          model: {
                                            value: _vm.form.password,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "password",
                                                $$v
                                              )
                                            },
                                            expression: "form.password"
                                          }
                                        }),
                                        _vm._v(" "),
                                        !_vm.$v.form.password.required
                                          ? _c(
                                              "span",
                                              { staticClass: "md-error" },
                                              [
                                                _vm._v(
                                                  "Das Passwort wird benötigt"
                                                )
                                              ]
                                            )
                                          : !_vm.$v.form.password.minlength
                                          ? _c(
                                              "span",
                                              { staticClass: "md-error" },
                                              [
                                                _vm._v(
                                                  "\n                    Ungültiges Passwort, bitte verwenden Sie mindestens 8\n                    Zeichen.\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "md-field",
                                      {
                                        class: _vm.getValidationClass(
                                          "repassword"
                                        )
                                      },
                                      [
                                        _c("label", [
                                          _vm._v("Neues Passwort wiederholen")
                                        ]),
                                        _vm._v(" "),
                                        _c("md-input", {
                                          attrs: {
                                            name: "repassword",
                                            type: "password",
                                            disabled: _vm.sending
                                          },
                                          model: {
                                            value: _vm.form.repassword,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "repassword",
                                                $$v
                                              )
                                            },
                                            expression: "form.repassword"
                                          }
                                        }),
                                        _vm._v(" "),
                                        !_vm.$v.form.repassword.required
                                          ? _c(
                                              "span",
                                              { staticClass: "md-error" },
                                              [
                                                _vm._v(
                                                  "Das Passwort wird benötigt"
                                                )
                                              ]
                                            )
                                          : !_vm.$v.form.repassword.minlength
                                          ? _c(
                                              "span",
                                              { staticClass: "md-error" },
                                              [
                                                _vm._v(
                                                  "\n                    Ungültiges Passwort, bitte verwenden Sie mindestens 8\n                    Zeichen.\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-primary",
                                        attrs: {
                                          type: "submit",
                                          disabled: _vm.sending
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Speichern\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.changepass
                        ? _c(
                            "md-list-item",
                            {
                              on: {
                                click: function($event) {
                                  _vm.active = true
                                }
                              }
                            },
                            [_vm._v("Account löschen")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "\n      md-layout-item\n      md-size-25\n      md-medium-size-10\n      md-small-size-10\n      md-xsmall-size-0\n    "
      }),
      _vm._v(" "),
      _c("md-dialog-confirm", {
        attrs: {
          "md-active": _vm.active,
          "md-title": "Wollen Sie Ihren Account wirklich löschen?",
          "md-content":
            "Nach einem Klick auf Löschen wird Ihr Account und alle damit verknüpften, persönlichen Daten gelöscht. Sie können diese Aktion nicht rückgängig machen und müssen sich, falls Sie WERNER erneut nutzen möchen, neu registrieren.",
          "md-confirm-text": "LÖSCHEN",
          "md-cancel-text": "Abbrechen"
        },
        on: {
          "update:mdActive": function($event) {
            _vm.active = $event
          },
          "update:md-active": function($event) {
            _vm.active = $event
          },
          "md-cancel": _vm.onCancel,
          "md-confirm": _vm.onConfirm
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f5ef03e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f5ef03e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/settings/Settings.vue
// module id = null
// module chunks = 